import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/misc/logo-small.png';

class Footercontent extends Component {
  render() {
    return (
      <Fragment>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-3 col-md-4 col-sm-12 footer-widget'>
              <div className='footer-logo'>
                <img src={logo} alt='acres' />
              </div>
              <ul className='social-media'>
                <li>
                  {' '}
                  <Link to='#'>
                    {' '}
                    <i className='fab fa-facebook-f' />{' '}
                  </Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='#'>
                    {' '}
                    <i className='fab fa-linkedin-in' />{' '}
                  </Link>{' '}
                </li>
              </ul>
            </div>
            <div className='col-lg-2 offset-md-1 col-md-4 col-sm-6 footer-widget'>
              <h5 className='widget-title'>Menu</h5>
              <ul>
                <li>
                  {' '}
                  <Link to='/'>Home</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='/listings'>Listings</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='/submit-listing'>Submit listing</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='/agents'>Agents</Link>{' '}
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-3 col-sm-6 footer-widget'>
              <h5 className='widget-title'>Legal</h5>
              <ul>
                <li>
                  {' '}
                  <Link to='/about'>About us</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='/privacy'>Privacy Policy</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='#'>Cookie Policy</Link>{' '}
                </li>
                <li>
                  {' '}
                  <Link to='/contact'>Contact us</Link>{' '}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='footer-bottom'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-7'>
                <p className='m-0'>
                  © Copyright 2022 - <Link to='#'>iProland Real Estate</Link>{' '}
                  All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Footercontent;
